import { MutableRefObject, useEffect, useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import { Button } from "../ui/button";
import { TutorFormDataI } from "./TutorRegistration";

const OTPtimer = ({
  timerIntervalRef,
  formData,
  setError,
  setMsg,
}: {
  timerIntervalRef: MutableRefObject<NodeJS.Timeout>;
  formData: TutorFormDataI;
  setError: (x: string) => void;
  setMsg: (x: string) => void;
}) => {
  const [timer, setTimer] = useState(300);
  const [isPending, setIsPending] = useState(false);

  const startTimer = () => {
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    setTimer(300);
    timerIntervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev === 0) {
          timerIntervalRef.current && clearInterval(timerIntervalRef.current);
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleCreateOTP = async () => {
    try {
      setIsPending(true);
      setError("");
      setMsg("");
      const response = await fetch(endpoints.createOTP, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          user_login: formData.phone,
          user_email: formData.email,
        }),
      });
      const res = await response.json();
      if (!response.ok) {
        throw Error(res.data);
      }
      startTimer();
      setMsg("تم إرسال رمز جديد الى الإيميل");
    } catch (e) {
      console.error();
      setError(e.message);
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    startTimer();
    return () => {
      timerIntervalRef.current && clearInterval(timerIntervalRef.current);
    };
  }, []);

  const minutes = Math.floor(timer / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (timer % 60).toString().padStart(2, "0");

  if (isPending)
    return (
      <div className="my-3 text-center">
        <Button disabled>إعادة إرسال الرمز ...</Button>
      </div>
    );

  if (timer <= 0) {
    return (
      <div className="my-3 text-center">
        <Button onClick={handleCreateOTP}>إعادة إرسال الرمز</Button>
      </div>
    );
  }

  return (
    <div className="my-3 text-center">
      <p>
        يمكنك طلب رمز اخر بعد {minutes}:{seconds}
      </p>
    </div>
  );
};

export default OTPtimer;
